<template>
	<div class="foot-box foot">
		<div class="foot-link">
			<router-link to="/us" tag="a" target="_blank" class="normal"
				>关于我们</router-link
			><span>|</span>
			<router-link to="/contact" tag="a" target="_blank" class="normal"
				>联系我们</router-link
			><span>|</span>
			<router-link to="/notices" tag="a" target="_blank" class="normal"
				>法律声明</router-link
			><span>|</span>
			<router-link to="/privacy" tag="a" target="_blank" class="normal"
				>隐私与条款</router-link
			><span>|</span>
			<router-link to="/recruitment" tag="a" target="_blank" class="normal"
				>人才招聘</router-link
			>
			<span>|</span>
			<router-link to="/convention" tag="a" target="_blank" class="normal"
				>人才招聘</router-link
			>
			<!-- <a href="/foot-about-us" target="_blank">关于我们</a> <span>|</span>
      <a href="/foot-contact-us" target="_blank">联系我们</a> <span>|</span>
      <a href="/foot-legal-notices" target="_blank">法律声明</a> <span>|</span>
      <a href="/foot-privacy-terms" target="_blank">隐私与条款</a>
      <span>|</span> <a href="/foot-recruitment" target="_blank">人才招聘</a> -->
		</div>
		<div class="copyright">
			<!-- <a
				target="_blank"
				href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010902002051"
				><img src="@/assets/gongan.png" />
				<span class="normal"> 苏公网安备 330109020xxxxx号</span></a
			>
			<a target="_blank" href="https://beian.miit.gov.cn" class="normal"
				>苏ICP备18019xxx号</a
			>
			<span>苏B2-20xx1xxx</span>
			<span>(苏)字第0xxxx号</span> -->
			<span>Copyright 苏广科技版权所有</span>
		</div>
	</div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>
.normal:hover {
	color: #ff4f1a;
}
.foot {
	padding: 12px 0;
	color: #666;
	background-color: #fafafa;
	.foot-link {
		font-size: 14px;
		line-height: 20px;
		text-align: center;
		> span {
			margin: 0 14px;
		}
	}
	.copyright {
		margin-top: 8px;
		line-height: 20px;
		text-align: center;
		> a {
			margin: 0 5px;
			-webkit-transition: color 0.2s ease;
			transition: color 0.2s ease;
		}
		> span {
			margin: 0 3px;
		}
	}
}
</style>
